<template>
<div id="public_affairs_app_tabbed">
    <PaTabbedMenu />
    <PaHeadingImage/>
    <div id="container">
        <div class="content">
            <PublicAffairsApp />
        </div>
    </div>
</div>
</template>

<script>

import PaTabbedMenu from './PaTabbedMenu.vue';
import PaHeadingImage from './PaHeadingImage.vue';
import PublicAffairsApp from './PublicAffairsApp.vue';

export default {
    name: 'public-affairs-app-tabbed',
    components: {
        PaTabbedMenu,
        PaHeadingImage,
        PublicAffairsApp,
    },
}
</script>

<style lang="scss">

</style>